import { createContext, useContext } from 'react';
import { ICoverage } from '../../../../interfaces/coverage.interface';

interface ICreateCoverageData {
    name: string;
    paymentMethod: string[];
    carName: string[];
    isVisible: boolean;
}

interface ICoverageContext {
    coverages: ICoverage[];
    loading: boolean;
    selected: ICoverage | null;
    isDrawing: boolean;
    pendingPolygon: number[][] | null;
    setSelected: (coverage: ICoverage | null) => void;
    setIsDrawing: (drawing: boolean) => void;
    fetchCoverages: () => void;
    handleDrawComplete: (polygon: number[][]) => void;
    confirmCreate: (data: ICreateCoverageData) => void;
    cancelCreate: () => void;
    handleUpdate: (id: string, data: Partial<ICoverage>) => void;
    handleDelete: (id: string) => void;
    handleToggleVisibility: (coverage: ICoverage) => void;
}

const CoverageContext = createContext<ICoverageContext | undefined>(undefined);

const useCoverageContext = () => {
    const context = useContext(CoverageContext);
    if (context === undefined) {
        throw new Error('useCoverageContext must be used within a CoverageProvider');
    }
    return context;
};

export { CoverageContext, useCoverageContext };
